import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: "wk-dashboard-access",
    templateUrl: "./dashboard-access.component.html",
    styleUrl: "./dashboard-access.component.scss",
    standalone: false,
    host: {
        class: "wk-sdm-da",
    },
})
export class DashboardAccessComponent {
    bsModalRef = inject(BsModalRef);

    access: boolean | undefined;
    title: string;
    loading: boolean;
    callback: Function;

    constructor() {}

    submitForm() {
        this.loading = true;
        this.callback(this.access);
    }
}
